import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './styles/global.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from './app/providers/AuthProvider';
import App from './App';
import { ConfigProvider } from 'antd';
import { antdTheme } from './theme';
import ThemeProvider from './theme/ThemeProvider';
import esES from 'antd/es/locale/es_ES';

const container = document.getElementById('root');
const root = createRoot(container);

const onRedirectCallback = (appState) => {
  console.log('[Auth0] onRedirectCallback llamado, appState:', appState);
  console.log('[Auth0] checkout_returnTo en sessionStorage:', sessionStorage.getItem('checkout_returnTo'));
  // Limpiar ?code= y ?state= de la URL
  window.history.replaceState({}, document.title, window.location.pathname);
};

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      <ConfigProvider locale={esES} theme={antdTheme}>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </ConfigProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
